<template>
  <div class="main">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link :to="'/jobs/' + eventId + '/days'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <h2>Day Details</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-sm">
          <div class="label-value-unit">
            <div class="micro-label">date</div>
            <div class="value">{{ dayData.date }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">start time</div>
            <div class="value">{{ amPmConvert(dayData.start_time) }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">end time</div>
            <div class="value">{{ amPmConvert(dayData.end_time) }}</div>
          </div>
        </div>
        <div class="col-sm d-flex flex-column align-items-start">
          <h5 class="mb-x1">Actions</h5>
          <router-link :to="'/jobs/' + eventId + '/days/edit/' + dayId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1">
            <i class="fas fa-pen mr-x1"></i>Edit Day
          </router-link>
          <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline mb-x1" @click="verifyDelete = true">
            <i class="fas fa-trash mr-x1"></i>Delete this day
          </button>
        </div>
      </div>
    </div>
    <!-- modal town -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDelete }">
      <div class="modal-card">
        <h4>Delete this day?</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteDay()">
          <i class="fas fa-trash mr-x1"></i>Delete this day
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDelete = false">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import PageLoader from '@/components/PageLoader.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      dayId: '',
      dayData: {
        'date': '',
        'start_time': '',
        'end_time': ''
      },
      verifyDelete: false
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.eventId = this.$route.params.eventid
    }
    if (this.$route.params.dayid) {
      this.dayId = this.$route.params.dayid
      this.getDay()
    }
  },
  methods: {
    getDay () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/days/' + this.dayId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.dayData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteDay () {
      this.isLoading = true
      axios
        .delete(apiChoice + 'api/days/' + this.dayId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.$router.push({ path: '/jobs/' + this.eventId + '/days' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
